import React, { useLayoutEffect, useMemo } from 'react';
import { Icon } from '../components/sp-primitives';
import { PShell, SpWorkspaceLoading, useApp } from '../components/sp-shell';
import { ROUTES } from '../routes';

const SHELL_IDS = new Set(['dashboard', 'import', 'approve', 'payments', 'creditors', 'templates', 'users', 'companies']);

/** Rota dedicada `empty` → `document.body.id === 'page-empty'` (ver `page-empty.css`). */
export function PEmpty() {
  const app = useApp();
  const shellActive = useMemo(() => {
    const shellFromParams = app.params?.shell;
    if (SHELL_IDS.has(shellFromParams)) return shellFromParams;
    if (app.route === ROUTES.COMPANY_CREDITORS) return 'creditors';
    if (app.route === ROUTES.TEMPLATES) return 'templates';
    return SHELL_IDS.has(app.route) ? app.route : 'dashboard';
  }, [app.params?.shell, app.route]);

  useLayoutEffect(() => {
    const activeCompanies = app.companies.filter((c) => String(c.status || '').toLowerCase() === 'active');
    if (!app.workspaceReady) return;
    if (activeCompanies.length > 0) {
      app.navigate(ROUTES.DASHBOARD);
    }
  }, [app.workspaceReady, app.companies, app.navigate]); // eslint-disable-line react-hooks/exhaustive-deps

  if (app.authToken && !app.workspaceReady) {
    return (
      <SpWorkspaceLoading
        active={shellActive}
        title="A preparar o seu espaço de trabalho…"
      />
    );
  }

  return (
    <PShell active={shellActive}>
      <div className="sp-screen-intro">
        <div className="sp-caps sp-screen-head__caps">Bem-vindo ao Sienge Pay</div>
        <h1 className="sp-screen-head__title">Vamos configurar sua primeira integração.</h1>
      </div>
      <div className="sp-card sp-onboard-hero">
        <div className="sp-onboard-icon">
          <Icon name="building" size={34} stroke={1.4} />
        </div>
        <div className="sp-onboard-title">Nenhuma empresa cadastrada</div>
        <div className="sp-onboard-lead">
          Cadastre sua primeira empresa para começar a importar folhas. Você vai precisar da URL da API, usuário e senha do usuário API Sienge.
        </div>
        <div className="sp-onboard-actions">
          <button type="button" className="sp-btn sp-btn-outline" onClick={() => app.navigate('templates')}>Ver documentação</button>
          <button type="button" className="sp-btn sp-btn-accent" onClick={() => app.navigate('company-new')}><Icon name="plus" size={13} /> Registrar primeira empresa</button>
        </div>
      </div>

      <div className="sp-onboard-steps">
        {[
          ['1', 'Cadastre a empresa', 'Nome, CNPJ e credenciais Sienge.', 'building', true],
          ['2', 'Crie um modelo', 'Mapeie as colunas do seu CSV.', 'file', false],
          ['3', 'Importe sua primeira folha', 'Audite e envie ao ERP.', 'upload', false],
        ].map(([n, t, d, ic, act]) => (
          <div key={n} className={`sp-card sp-onboard-step${act ? '' : ' is-future'}`}>
            <div className="sp-onboard-step__head">
              <div className={`sp-onboard-step__badge${act ? ' is-active' : ''}`}>{n}</div>
              <Icon name={ic} size={16} />
            </div>
            <div className="sp-onboard-step__title">{t}</div>
            <div className="sp-onboard-step__desc">{d}</div>
            {n === '1' && (
              <button
                type="button"
                className="sp-btn sp-btn-outline sp-onboard-step__cta"
                onClick={() => app.navigate('company-new')}
              >
                clique aqui
              </button>
            )}
          </div>
        ))}
      </div>
    </PShell>
  );
}
